import React from 'react';
import { Card, CardActionArea, CardMedia, Skeleton, CardContent, Typography } from '@mui/material';

const OGPDisplay = ({
  title,
  image,
  description,
  url,
  image_height = '140'
}) => {
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardActionArea, {
    href: url || ''
  }, image ? /*#__PURE__*/React.createElement(CardMedia, {
    component: "img",
    height: image_height,
    image: image,
    alt: title || url || ''
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    variant: "rectangular",
    width: "100%",
    height: Number(image_height)
  }), /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, title || /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, ((description == null ? void 0 : description.length) || 0) > 280 ? (description || '').slice(0, 280) + '...' : description || /*#__PURE__*/React.createElement(Skeleton, null))))));
};

export { OGPDisplay };
